<template>
    <div id="configurator" :class="{'overview': $route.name != 'Configurator'}">
        <header>
            <div class="navigation--main">
                <div class="container">
                    <img src="https://www.loxone.com/wp-content/uploads/sites/2/2017/12/loxone_logo.png">
                    <div class="icon__wrapper">
                        <a v-if="$store.state.loggedIn" href="https://portal.loxone.com" class="icon icon--clickable">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.71421 16.4302H16.4284C16.3965 15.4857 16.168 14.5582 15.7576 13.7068C15.2545 12.7073 13.0744 12.0298 10.3912 11.0236V9.01119C10.7036 8.77687 10.9572 8.47304 11.1318 8.12375C11.3065 7.77446 11.3974 7.3893 11.3974 6.99878C11.7328 6.99878 12.0682 5.65718 11.3974 5.32178C11.3974 5.12725 12.2963 3.44354 12.0682 2.30318C11.7328 0.626175 7.03721 0.626175 6.70181 1.96778C4.68941 1.96778 6.03101 5.05346 6.03101 5.32178C5.36021 5.65718 5.69561 6.99878 6.03101 6.99878C6.03101 7.3893 6.12193 7.77446 6.29658 8.12375C6.47122 8.47304 6.72479 8.77687 7.03721 9.01119V11.0236C4.354 12.0298 2.16719 12.7073 1.6708 13.7068C1.26042 14.5582 1.03197 15.4857 1 16.4302H8.71421Z" stroke="white" stroke-linejoin="round"/>
                            </svg>
                        </a>
                        <a v-else href="https://portal.loxone.com/login/?r=https://configurator.loxone.com" class="icon icon--clickable">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.71421 16.4302H16.4284C16.3965 15.4857 16.168 14.5582 15.7576 13.7068C15.2545 12.7073 13.0744 12.0298 10.3912 11.0236V9.01119C10.7036 8.77687 10.9572 8.47304 11.1318 8.12375C11.3065 7.77446 11.3974 7.3893 11.3974 6.99878C11.7328 6.99878 12.0682 5.65718 11.3974 5.32178C11.3974 5.12725 12.2963 3.44354 12.0682 2.30318C11.7328 0.626175 7.03721 0.626175 6.70181 1.96778C4.68941 1.96778 6.03101 5.05346 6.03101 5.32178C5.36021 5.65718 5.69561 6.99878 6.03101 6.99878C6.03101 7.3893 6.12193 7.77446 6.29658 8.12375C6.47122 8.47304 6.72479 8.77687 7.03721 9.01119V11.0236C4.354 12.0298 2.16719 12.7073 1.6708 13.7068C1.26042 14.5582 1.03197 15.4857 1 16.4302H8.71421Z" stroke="white" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
            <div class="navigation--sub">
                <div class="container" v-if="$route.name == 'Configurator'">
                <div>
                    <router-link to="/">
                        <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9988 7.33333C12.9988 6.96514 13.2972 6.66667 13.6654 6.66667H18.3321C18.7003 6.66667 18.9988 6.96514 18.9988 7.33333V9.25114C19.6876 9.53074 20.3329 9.90565 20.9179 10.3627L22.5827 9.40133C22.7359 9.31292 22.9178 9.28895 23.0886 9.33471C23.2594 9.38047 23.405 9.4922 23.4934 9.64533L25.8268 13.6867C26.0108 14.0055 25.9017 14.4131 25.5829 14.5973L23.917 15.5597C24.0227 16.3076 24.0208 17.0522 23.9186 17.7765L25.5816 18.7374C25.9004 18.9216 26.0095 19.3292 25.8254 19.648L23.4921 23.6893C23.4037 23.8425 23.258 23.9542 23.0872 24C22.9164 24.0457 22.7344 24.0217 22.5813 23.9333L20.9151 22.9708C20.3409 23.4185 19.6983 23.7914 18.9988 24.0736V26C18.9988 26.3682 18.7003 26.6667 18.3321 26.6667H13.6654C13.2972 26.6667 12.9988 26.3682 12.9988 26V24.0789C12.3115 23.799 11.6672 23.425 11.0827 22.9691L9.41746 23.9307C9.26434 24.0191 9.08236 24.043 8.91157 23.9973C8.74078 23.9515 8.59516 23.8398 8.50675 23.6867L6.17342 19.6453C5.98935 19.3265 6.09852 18.9189 6.41728 18.7347L8.0832 17.7723C7.97746 17.0249 7.97926 16.2814 8.08069 15.5584L6.41724 14.5972C6.09851 14.4131 5.98936 14.0054 6.17342 13.6867L8.50675 9.64533C8.59517 9.49218 8.74082 9.38044 8.91164 9.33469C9.08246 9.28895 9.26445 9.31294 9.41758 9.4014L11.0839 10.364C11.6576 9.91651 12.2988 9.54277 12.9988 9.2607V7.33333ZM13.643 14.3096C14.2681 13.6845 15.1159 13.3333 16 13.3333C16.8841 13.3333 17.7319 13.6845 18.357 14.3096C18.9821 14.9348 19.3333 15.7826 19.3333 16.6667C19.3333 17.5507 18.9821 18.3986 18.357 19.0237C17.7319 19.6488 16.8841 20 16 20C15.1159 20 14.2681 19.6488 13.643 19.0237C13.0179 18.3986 12.6667 17.5507 12.6667 16.6667C12.6667 15.7826 13.0179 14.9348 13.643 14.3096Z" fill="#69C350"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68648 0 0 2.68648 0 6V26C0 29.3135 2.68648 32 6 32H26C29.3135 32 32 29.3135 32 26V6C32 2.68648 29.3135 0 26 0H6ZM1.33333 6C1.33333 3.42286 3.42286 1.33333 6 1.33333H26C28.5771 1.33333 30.6667 3.42286 30.6667 6V26C30.6667 28.5771 28.5771 30.6667 26 30.6667H6C3.42286 30.6667 1.33333 28.5771 1.33333 26V6Z" fill="#69C350"/>
                        </svg>
                    </router-link>
                        <span class="title">
                            <router-link to="/">
                            Loxone Configurator
                            </router-link>
                            <span class="config__id">
                                | {{$store.state.configurationId}}
                            </span>
                        </span>
                    </div>
                        <img v-if="$route.name == 'Management'" src="@/assets/images/management.gif" height="40" width="40"/>
                    <template v-if="$store.state.configurationType == 'edit'">
                        <div class="interactive__buttons">
                            <div class="dynamic--loader">
                                <template v-if="$store.state.loggedIn">
                                    <template v-if="$store.state.configuratorSaving">
                                        <svg class="loading" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="7.19922" width="1.6" height="4.8" rx="0.8" fill="black" fill-opacity="0.2"/>
                                            <g opacity="0.9">
                                                <rect x="13.0898" y="1.77734" width="1.6" height="4.8" rx="0.8" transform="rotate(45 13.0898 1.77734)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                            <g opacity="0.8">
                                                <rect x="16" y="7.19922" width="1.6" height="4.8" rx="0.8" transform="rotate(90 16 7.19922)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                            <g opacity="0.7">
                                                <rect x="14.2227" y="13.0898" width="1.6" height="4.8" rx="0.8" transform="rotate(135 14.2227 13.0898)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                            <g opacity="0.6">
                                                <rect x="8.80078" y="16" width="1.6" height="4.8" rx="0.8" transform="rotate(180 8.80078 16)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                            <g opacity="0.5">
                                                <rect x="2.91016" y="14.2227" width="1.6" height="4.8" rx="0.8" transform="rotate(-135 2.91016 14.2227)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                            <g opacity="0.4">
                                                <rect y="8.80078" width="1.6" height="4.8" rx="0.8" transform="rotate(-90 0 8.80078)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                            <g opacity="0.3">
                                                <rect x="1.77734" y="2.91016" width="1.6" height="4.8" rx="0.8" transform="rotate(-45 1.77734 2.91016)" fill="black" fill-opacity="0.2"/>
                                            </g>
                                        </svg>
                                        <span>{{$t('saving')}}</span>
                                    </template>
                                    <template v-else>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.3412 8.86553C17.543 8.67711 17.5539 8.36072 17.3655 8.15884C17.1771 7.95697 16.8607 7.94606 16.6588 8.13447L9.51198 14.8049L7.35355 12.6464C7.15829 12.4512 6.84171 12.4512 6.64645 12.6464C6.45118 12.8417 6.45118 13.1583 6.64645 13.3536L9.14645 15.8536C9.33697 16.0441 9.64419 16.0494 9.84116 15.8655L17.3412 8.86553Z" fill="black" fill-opacity="0.2"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" fill="black" fill-opacity="0.2"/>
                                        </svg>
                                        <span>{{$t('saved')}}</span>
                                    </template>
                                </template>
                                <template v-else>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 6C12.2761 6 12.5 6.22386 12.5 6.5V13.5C12.5 13.7761 12.2761 14 12 14C11.7239 14 11.5 13.7761 11.5 13.5V6.5C11.5 6.22386 11.7239 6 12 6Z" fill="red"/>
                                        <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z" fill="red"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" fill="red"/>
                                    </svg>
                                    <span style="color:Red;">{{$t('not_saved')}}</span>
                                </template>
                            </div>
                            <template v-if="$store.state.loggedIn">
                                <router-link class="btn btn--ghost" to="/">{{$t('back_to_overview')}}</router-link> 
                                <a @click="share()" class="btn btn--ghost">{{$t('share_config')}}</a>
                                <template v-if="$store.state.configurationGlowing  && $store.state.configurationSku != 100508 && $store.state.configurationSku != 100507 || !$store.state.configurationGlowing && $store.state.configurationSku != 100508 && $store.state.configurationSku != 100507">
                                    <a @click="order()" class="btn">{{$t('order')}}</a>
                                </template>
                            </template>
                            <template v-else>
                                <a @click="saveToAccount()" class="btn btn--ghost">{{$t('save')}}</a> 
                                <a @click="share()" class="btn btn--ghost">{{$t('share_config')}}</a> 
                                <template v-if="$store.state.configurationGlowing  && $store.state.configurationSku != 100508 && $store.state.configurationSku != 100507 || !$store.state.configurationGlowing && $store.state.configurationSku != 100508 && $store.state.configurationSku != 100507">
                                    <a @click="orderAndSaveToAccount()" class="btn">{{$t('order')}}</a>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="interactive__buttons">
                            <router-link v-if="$store.state.loggedIn" class="btn btn--ghost" to="/">{{$t('back_to_overview')}}</router-link> 
                            <a @click="duplicate()" class="btn btn--ghost">{{$t('duplicate')}}</a>
                        </div>
                    </template>
                </div>
                <div v-else class="container">
                    <div>
                    <router-link to="/">
                        <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9988 7.33333C12.9988 6.96514 13.2972 6.66667 13.6654 6.66667H18.3321C18.7003 6.66667 18.9988 6.96514 18.9988 7.33333V9.25114C19.6876 9.53074 20.3329 9.90565 20.9179 10.3627L22.5827 9.40133C22.7359 9.31292 22.9178 9.28895 23.0886 9.33471C23.2594 9.38047 23.405 9.4922 23.4934 9.64533L25.8268 13.6867C26.0108 14.0055 25.9017 14.4131 25.5829 14.5973L23.917 15.5597C24.0227 16.3076 24.0208 17.0522 23.9186 17.7765L25.5816 18.7374C25.9004 18.9216 26.0095 19.3292 25.8254 19.648L23.4921 23.6893C23.4037 23.8425 23.258 23.9542 23.0872 24C22.9164 24.0457 22.7344 24.0217 22.5813 23.9333L20.9151 22.9708C20.3409 23.4185 19.6983 23.7914 18.9988 24.0736V26C18.9988 26.3682 18.7003 26.6667 18.3321 26.6667H13.6654C13.2972 26.6667 12.9988 26.3682 12.9988 26V24.0789C12.3115 23.799 11.6672 23.425 11.0827 22.9691L9.41746 23.9307C9.26434 24.0191 9.08236 24.043 8.91157 23.9973C8.74078 23.9515 8.59516 23.8398 8.50675 23.6867L6.17342 19.6453C5.98935 19.3265 6.09852 18.9189 6.41728 18.7347L8.0832 17.7723C7.97746 17.0249 7.97926 16.2814 8.08069 15.5584L6.41724 14.5972C6.09851 14.4131 5.98936 14.0054 6.17342 13.6867L8.50675 9.64533C8.59517 9.49218 8.74082 9.38044 8.91164 9.33469C9.08246 9.28895 9.26445 9.31294 9.41758 9.4014L11.0839 10.364C11.6576 9.91651 12.2988 9.54277 12.9988 9.2607V7.33333ZM13.643 14.3096C14.2681 13.6845 15.1159 13.3333 16 13.3333C16.8841 13.3333 17.7319 13.6845 18.357 14.3096C18.9821 14.9348 19.3333 15.7826 19.3333 16.6667C19.3333 17.5507 18.9821 18.3986 18.357 19.0237C17.7319 19.6488 16.8841 20 16 20C15.1159 20 14.2681 19.6488 13.643 19.0237C13.0179 18.3986 12.6667 17.5507 12.6667 16.6667C12.6667 15.7826 13.0179 14.9348 13.643 14.3096Z" fill="#69C350"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68648 0 0 2.68648 0 6V26C0 29.3135 2.68648 32 6 32H26C29.3135 32 32 29.3135 32 26V6C32 2.68648 29.3135 0 26 0H6ZM1.33333 6C1.33333 3.42286 3.42286 1.33333 6 1.33333H26C28.5771 1.33333 30.6667 3.42286 30.6667 6V26C30.6667 28.5771 28.5771 30.6667 26 30.6667H6C3.42286 30.6667 1.33333 28.5771 1.33333 26V6Z" fill="#69C350"/>
                        </svg>
                    </router-link>
                        <span class="title">
                            <router-link to="/">Loxone Configurator</router-link>
                        </span>
                    </div>
                    <template v-if="$route.name == 'Touch_Flex'">
                        <div class="touch__flex--search">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.64605 10.4111C3.82497 9.38469 3.33398 8.08269 3.33398 6.66602C3.33398 3.35231 6.02028 0.666016 9.33398 0.666016C12.6477 0.666016 15.334 3.35231 15.334 6.66602C15.334 9.97972 12.6477 12.666 9.33398 12.666C7.91731 12.666 6.61531 12.175 5.58886 11.3539L1.80539 15.1374C1.54504 15.3978 1.12293 15.3978 0.86258 15.1374C0.602231 14.8771 0.602231 14.455 0.86258 14.1946L4.64605 10.4111ZM9.33398 11.3327C11.9113 11.3327 14.0007 9.24334 14.0007 6.66602C14.0007 4.08869 11.9113 1.99935 9.33398 1.99935C6.75666 1.99935 4.66732 4.08869 4.66732 6.66602C4.66732 9.24334 6.75666 11.3327 9.33398 11.3327Z" fill="black"/>
                            </svg>
                            <input spellcheck="false" v-model="$store.state.flexSearchTerm" type="text" placeholder="Search" />
                        </div>
                    </template>
                </div>
            </div>
        </header>
        <div class="container no--padding">
            <div class="content">
                <main>
                    <router-view/>
                </main>
            </div>
        </div>
        <div v-if="$store.state.newTouchFlexInterfaceVisible" class="overlay__wrapper overlay__wrapper--new" style="position: fixed;z-index:99999;">
            <div class="overlay__content">
                <div class="overlay__content--left">
                    <div style="transform: scale(0.5);transform-origin: left top;width:270px;height:270px;">
                        <template v-if="currentVariant != ''">
                            <touch-flex :key="$store.state.newTouchFlexConfiguration" :configuration="$store.state.newTouchFlexConfiguration"></touch-flex>
                        </template>
                    </div>
                </div>
                <div class="overlay__content--right" style="background-color: #FFFFFF;">
                    <h3>{{$t('new_touch_flex')}}</h3>
                    <div class="box__group--input">
                        <label>{{$t('variant')}}<span class="required">*</span></label>
                        <div class="dropdown__group--wrapper">
                            <div>
                                <div @click="variantsVisible = !variantsVisible" class="dropdown__group--selected">
                                <template v-if="currentVariant != ''">
                                    <div class="name">{{$t('products.touch_flex.' + currentVariant)}}</div>
                                    <div class="desc">{{$t('article_no')}} 
                                        {{currentVariant}}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="name">{{$t('choose_variant')}}</div>
                                </template>
                                    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.5 1L5.5 5L9.5 1" stroke="#808080" stroke-width="1.5"/>
                                    </svg>
                                </div>
                            </div>
                            <div v-if="variantsVisible" class="dropdown--list">
                                <div @click="currentVariant = 100609;variantsVisible=false;" class="list__entry">
                                    <!-- Tree Anthracite (Backlight) -->
                                    <div class="name">{{$t('products.touch_flex.100609')}}</div>
                                    <div class="desc">{{$t('article_no')}} 100609</div>
                                </div>
                                <div @click="currentVariant = 100608;variantsVisible=false;" class="list__entry">
                                    <!-- Tree White (Backlight) -->
                                    <div class="name">{{$t('products.touch_flex.100608')}}</div>
                                    <div class="desc">{{$t('article_no')}} 100608</div>
                                </div>
                                <div @click="currentVariant = 100611;variantsVisible=false;" class="list__entry">
                                    <!-- 24V Air Anthracite (Backlight) -->
                                    <div class="name">{{$t('products.touch_flex.100611')}}</div>
                                    <div class="desc">{{$t('article_no')}} 100611</div>
                                </div>
                                <div @click="currentVariant = 100610;variantsVisible=false;" class="list__entry">
                                    <!-- 24V Air White (Backlight) -->
                                    <div class="name">{{$t('products.touch_flex.100610')}}</div>
                                    <div class="desc">{{$t('article_no')}} 100610</div>
                                </div>
                                <div @click="currentVariant = 100510;variantsVisible=false;" class="list__entry">
                                    <!-- Battery Air White -->
                                    <div class="name">{{$t('products.touch_flex.100510')}}</div>
                                    <div class="desc">{{$t('article_no')}} 100510</div>
                                </div>
                                <div @click="currentVariant = 100509;variantsVisible=false;" class="list__entry">
                                    <!-- Battery Air Anthracite -->
                                    <div class="name">{{$t('products.touch_flex.100509')}}</div>
                                    <div class="desc">{{$t('article_no')}} 100509</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box__group--input">
                        <label>{{$t('description')}}<span class="required">*</span>
                            <div class="box__group--icon">
                                <div class="box__headline--info">
                                    <img src="/assets/images/description.png" />
                                    <h3>{{$t('description')}}</h3>
                                    <p>{{$t('description_info')}}</p>
                                </div>
                            </div>
                        </label>
                        <textarea spellcheck="false" v-model="currentDescription" :placeholder="$t('application_purpose')" rows="3"></textarea>
                    </div>
                    <div>
                        <a @click="$store.state.newTouchFlexInterfaceVisible=false;currentVariant='';currentDescription='';$store.state.newTouchFlexConfiguration={}" class="btn btn--ghost">{{$t('cancel')}}</a>                        
                        <a disabled="disabled" @click="if(currentVariant != ''){createNewConfiguration()};" class="btn" :class="{'btn--disabled': currentVariant == ''}">{{$t('continue')}}</a>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    import TouchFlex from '@/components/TouchFlex.vue';

    export default {
        components: {
            TouchFlex,
        },
        computed:{
        },
        data() {
            return {
                variantsVisible: false,
                currentDescription: '',
                currentVariant: '',
                langs: [
                    'dede',
                    'enen',
                    'frfr',
                    'cscz',
                    'eses',
                    'nlnl',
                    'itit',
                    'huhu',
                    'enus',
                    'plpl',
                    'caes',
                    'sksk',
                    'int'
                ]
            }
        },
        methods: {
            createNewConfiguration() {
                var configurationData = new FormData();
                configurationData.append('configuration_id', this.$store.state.newTouchFlexConfiguration.id);
                configurationData.append('sku', this.currentVariant);
                configurationData.append('desc', this.currentDescription);

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    data: configurationData,
                    url: 'https://configurator.loxone.com/api/createNewConfiguration',
                })
                .then(resp => {
                    if (resp.data) {
                        this.$store.state.newTouchFlexInterfaceVisible=false;
                        this.currentVariant = '';
                        this.currentDescription='';
                        this.$store.state.newTouchFlexConfiguration={};
                        
                        this.$router.push({
                            path: '/configurator/' + resp.data.configuration_id + '/edit/' + resp.data.hash
                        });
                    }

                });
            },
            duplicate() {
                //http://localhost:8080/configurator/TFXR940/preview/2cdc3455448e87c4102e2f9b679fbb2fa312daeb
                var configurationData = new FormData();
                configurationData.append('configuration_id', window.location.href.split('/')[4]);

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    data: configurationData,
                    url: 'https://configurator.loxone.com/api/createNewConfiguration',
                })
                .then(resp => {
                    if (resp.data) {
                        location.href = location.origin + '/configurator/' + resp.data.configuration_id + '/edit/' + resp.data.hash;
                    }

                });
            },
            orderAndSaveToAccount() {
                this.setCookie('saving_config_id', window.location.href.split('/')[4], 30);
                window.location.href = "https://portal.loxone.com/login/?r=https://configurator.loxone.com" + this.$route.fullPath + '/order';
            },
            saveToAccount() {
                this.setCookie('saving_config_id', window.location.href.split('/')[4], 30);
                window.location.href = "https://portal.loxone.com/login/?r=https://configurator.loxone.com/";
            },
            setCookie(name, value, days) {
                var expires = "";
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days*24*60*60*1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "")  + expires + "; path=/";
            },
            findAncestor (el, cls) {
                if(el.classList.contains(cls)) {
                    return el;
                }
                while ((el = el.parentElement) && !el.classList.contains(cls));
                return el;
            },
            updateLocale() {
                this.setCookie('portal_lang', this.$i18n.locale, 365);
            },
            setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=loxone.com;path=/";
            },
            order() {
                this.$store.state.shareOverlayVisible = false;
                this.$store.state.buyOverlayVisible = true;
            },
            share() {
                this.$store.state.buyOverlayVisible = false;            
                this.$store.state.shareOverlayVisible = true;    
            },
        },
        watch: {

            currentDescription: {
                handler() {
                    if(this.currentDescription) {
                        this.currentDescription = this.currentDescription.substr(0, 50).replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                    }
                }
            },
            currentVariant: {
                handler(newVal, oldVal) {
                    this.$store.state.newTouchFlexConfiguration.sku = newVal;
                },
                immediate: true,
            },
            '$route': function () {
				window.scrollTo(0, 0);

				var checkData = new FormData;
				checkData.append('data', JSON.stringify(this.$store.state.userData));
                				
                axios({
					method: 'post',
					crossDomain: true,
					withCredentials: true,
					data: checkData,
					url: 'https://portal.loxone.com/api/checkUserSession',
				})
				.then(resp => {
					if(!resp.data.loggedIn) {
					}
					if (resp.data && resp.data.valid) {
						this.$store.state.loggedIn = resp.data.valid;

						if (resp.data.userData) {
                            this.$store.state.userData.loaded = true;
							this.$store.state.userData.content = resp.data.userData;
						}
					}
				});
            },
        },
        created() {
            axios({
					method: 'post',
					crossDomain: true,
					withCredentials: true,
					url: 'https://portal.loxone.com/api/checkUserSession',
				})
				.then(resp => {				
				});

			document.title = 'Loxone Configurator';

            if(location.search.includes('forcereload')) {
                localStorage.clear();
            }
			function getCookie(cname) {
				var name = cname + "=";
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for(var i = 0; i <ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
					c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
					}
				}
				return "";
			}
        },
    }
</script>

<style lang="scss">
	@import "./scss/_style.scss";

    .touch__flex--search{
        padding: 17px 0;
        height: 30px;
        position: relative;

        svg{
            position: absolute;
            top: 25px;
            left: 8px;
        }

        input{
            line-height: 10px;
            background-color: #F5F5F5;
            border: 1px solid #E6E6E6;
            outline: none;
            font-size: 14px;
            line-height: 30px;
            padding: 0 10px 0 30px;
        }
    }

    .icon__wrapper{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 10px;

        .icon{
            position: relative;
            width: 24px;
            height: 48px;
            display: flex;
            align-content: center;
            justify-content: center;
            align-items: center;

            .icon--clickable,
            &.icon--clickable{
                cursor: pointer;
            }

            .count{
                background-color: #E73246;
                width: 22px;
                height: 22px;
                display: inline-block;
                text-align: center;
                border-radius: 50%;
                color: white;
                font-size: 12px;
                line-height: 22px;
                position: absolute;
                top: 6px;
                right: 0;
            }

            .icon__box{
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
                position: absolute;
                font-size: 16px;
                line-height: 1.2em;
                top: 48px;
                right: -20px;
                background-color: #FFFFFF;
                padding: 20px;
                width: 380px;

                &.icon__box--settings{
                    width: 264px;
                    padding: 0 20px;

                }

                .icon__box--headline{
                    font-family: $ff-averta-extrabold;
                    padding-bottom: 8px;
                    border-bottom: 1px solid #000000;
                }

                .settings__box--top {
                    border-top: 1px solid #000000;
                    border-bottom: 1px solid #000000;
                    padding: 15px 0;

                    .router-link{
                        display: grid;
                        grid-template-columns: 20px auto;
                        grid-column-gap: 10px;
                        line-height: 20px;
                        margin: 10px 0;
                        color: #000000;

                        &:first-child{
                            margin-top: 0;
                        }

                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                }

                .settings__box--center{
                    border-bottom: 1px solid #000000;
                    padding: 15px 0;
                    text-align: right;

                    .language--switcher{
                        border: 1px solid black;
                        border-radius: 0;
                        font-size: 14px;
                        font-family: 'averta-regular', Arial, Helvetica, sans-serif;
                    }
                }

                .settings__box--bottom {
                    text-align: right;
                    padding: 10px 0;
                }
            }
        }
    }

    .interactive__buttons{
        padding: 8px 0;

        .btn{
            margin-left: 15px;
            font-size: 12px !important;
            line-height: 22px !important;
        }
    }

    .box__group--input{
        .dropdown__group--wrapper{
            position: relative;

            .dropdown--list{
                position: absolute;
                left: 0;
                right: 0;
                background-color: #FFFFFF;
                border-radius: 3px;
                box-shadow: 2px 2px 24px rgba(0, 0, 0, 0.12);
                z-index: 999;
                padding: 10px 10px 0 10px;


                .list__entry{
                    border: 1px solid #E6E6E6;
                    background-color: #F5F5F5;
                    padding: 5px;
                    cursor: pointer;
                    margin-bottom: 15px;
                }
            }

        }

        textarea{
            text-align: left !important;
        }
    }

    @media screen and (max-width: 1050px) {
        .content{
            grid-template-columns: 100% !important;
        }
        nav{
            display: none !important
        }
    }
</style>